const CommonRoutes = {
  NotFound: '/not-found',
}

export default CommonRoutes
